import React from 'react';
import Layout from '../../components/Layout';
import { Link } from 'react-router-dom';
import { ClassicBanner } from '../../components/Banner';
import { CreateBannerData } from './create-banner-data';
import CarouselBanner from '../../components/Banner/CarouselBanner/carousel-banner';

const CreateBirthdayPage = () => (
  <Layout>
    <section className='hero is-lavender is-bold'>
      <div className='hero-body'>
        <div className='container'>
          <div className='columns is-vcentered'>

            <div className='column is-12-mobile is-6' >
              <div className='section'>
                <h1 className='title has-text-weight-semibold is-size-3 has-text-grey'>
                  Create your birthday celebration wall
                </h1>
                <h2 className='is-size-5'></h2>

                <div className='is-10-mobile is-12'></div>
              </div>
            </div>

            <div className="column is-6 is-flex is-horizontal-center is-hidden-mobile">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className='section'>
      <div className="container">
        <div className="columns ">
          <div className="column">
            <article className="box is-hover-drop-shadow has-text-centered px-1 py-1 is-3" style={{ maxWidth: '500px', minWidth: '300px' }}>
              <p className="title mt-4">
                <span>Classic</span>
                <span className="tag is-primary ml-4 is-vertical-align-super">Free</span>
              </p>

              <Link to="/create/birthday/classic">
                <ClassicBanner data={CreateBannerData.classic} heroClassName="px-1 py-1 birthday-banner" compact/>

                <p className="title mb-1 has-text-grey">
                  <button className="button is-primary my-2 px-2 is-large is-fullwidth">Create</button>
                </p>
              </Link>
            </article>
          </div>

          <div className="column">
            <article className="box is-hover-drop-shadow has-text-centered px-1 py-1 is-3" style={{ maxWidth: '500px', minWidth: '300px' }}>
              <p className="title mt-4">
                <span>Carousel</span>
                <span className="tag is-primary ml-4 is-vertical-align-super">Free</span>
              </p>

              <Link to="/create/birthday/carousel">
                <CarouselBanner data={CreateBannerData.carousel} heroClassName="px-1 py-1 birthday-banner" compact />

                <p className="title mb-1 has-text-grey">
                  <button className="button is-primary my-2 px-2 is-large is-fullwidth">Create</button>
                </p>
              </Link>
            </article>
          </div>
    
        </div>






      </div>
    </section>

  </Layout>

);

export default CreateBirthdayPage;